import styled from 'styled-components'
import { mixins} from './../css-variables'

const StyledSeparatorLine = styled.hr` 
    ${mixins.full_width_line}
` 
export default StyledSeparatorLine
